import { OwnListService } from './../own-list.service';
import { Component, OnInit, ViewChild, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Global } from '../classes/Global';
import { UrlValidator } from '../helpers/UrlValidater';
import { GenresService } from '../genres.service';
import { OffersParentComponent } from '../classes/OffersParentComponent';
import { InfoService } from '../info.service';
import { WishlistService } from '../wishlist.service';
import { AuthenticationService } from '../authentication.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';
import { SettingsService } from '../settings.service';
import { ThemeService } from '../theme.service';
import { SeoService } from '../seo.service';
import { BlocklistService } from '../blocklist.service';
import { ListHelper } from '../helpers/ListHelper';

@Component({
  selector: 'app-blocklist',
  templateUrl: './blocklist.component.html',
  styleUrls: ['./blocklist.component.scss'],
  providers: [ OwnListService, GenresService, InfoService,
    WishlistService, AuthenticationService ]
})
export class BlocklistComponent extends OffersParentComponent implements OnInit, AfterViewInit {

  itemToRemove = null;
  @ViewChild("authentication", {static: false}) authentication;
  @ViewChild('dotsDDContent', {static: false}) dotsDDContent: ElementRef;
  @ViewChild('importWarning', {static: false}) importWarning;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      // Safely check classList - handle cross-origin iframe elements
      let hasThreeDots = false;
      let hasDropdown = false;
      try {
        const classList = event.target.classList;
        if (classList) {
          hasThreeDots = classList.contains("three-dots");
          hasDropdown = classList.contains("dropdown");
        }
      } catch (e) {
        // Permission denied when accessing classList from cross-origin iframe - ignore
        return;
      }
      if (!hasThreeDots && !hasDropdown && this.dotsDDContent) {
        this.closeDropdown(this.dotsDDContent);
      }
    } catch (e) {
    // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected genresService: GenresService,
    protected infoService: InfoService,
    protected wishlistService: WishlistService,
    protected blocklistService: BlocklistService,
    protected authenticationService: AuthenticationService,
    protected ownListService: OwnListService,
    protected settingsService: SettingsService,
    protected themeService: ThemeService,
    protected seoService: SeoService
  ) {
    super(
      genresService, router, route, authenticationService, infoService,
      wishlistService, blocklistService, ownListService, settingsService, themeService, seoService
    );
    this.cacheResults = false;
    this.identifier = Global.BLOCKLIST;
  }

  initSorting() {
    this.sortValues = this.getSortingValues();
    if (this.sortValues.indexOf(this.getSort('blocklist')) > -1) {
      this.sortKey = this.getSort('blocklist');
    } else {
      this.sortKey = this.sortValues[0];
    }
  }

  ngOnInit() {
    UrlValidator.validateUrl(this.route, this.router, Global.BLOCKLIST, this);
    this.getSessionTokenFromUrl();
    super.onInit();
    this.loadGenreAndItems();
  }

  ngAfterViewInit() {
    this.setScrollPosition();
  }

  //overriding parent method
  getMediaType() {
    return Global.getMediaTypeForWishlistRequest();
  }

  qualityOptionsHook(qualities: Array<any>): Array<any> {
    qualities.unshift({title: this.getString("all"), type: "all"});
    return qualities;
  }

  getOffers() {
    return this.blocklistService.getDetailItemList(StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
    Global.getStore(), Global.getMediaTypeForWishlistRequest(), Global.getCountry(),
    this.formatMultiSelectionForServer(this.selectedGenres, this.genres),
    this.getQuality(), this.sortKey, this.offset, this.limit);
  }

  reload(newUrl: boolean = false, replaceUrl?: boolean) {
    let mediaType = Global.getMediaType();
    if(mediaType == Global.BUYMOVIES || mediaType == Global.RENTALMOVIES) {
      mediaType = Global.MOVIES;
    }
    if(mediaType == Global.ALBUMS || mediaType == Global.SINGLES) {
      mediaType = Global.MUSIC;
    }
    const url = Global.getCountry() + '/' + Global.getStoreUrl() + '/' + this.getString(mediaType + "Url") + '/' + this.getString('blocklistUrl');
    const targetUrl = "/" + url;
    // Only navigate if URL actually changed to prevent excessive replaceState calls
    if (this.router.url !== targetUrl) {
      if (replaceUrl === true) {
        this.router.navigate([url], { replaceUrl: true }).then(_ => this.loadGenreAndItems());
      } else {
        this.router.navigate([url]).then(_ => this.loadGenreAndItems());
      }
    } else {
      this.loadGenreAndItems();
    }
  }

  getSortingValues() {
    return [
      Global.ADDED_TO_BLOCKLIST_AT,
      Global.ALPHABETICAL
    ];
  }

  getHeaderTitle(): string {
    return this.getString('blocklistHeaderTitle');
  }

  getHeaderText(): string {
    return this.getString('blocklistHeaderText');
  }

  removeFromBlocklist(item) {
    this.itemToRemove = null;
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
      if (sessionToken){

      let pluralItemType = Global.getPluralItemType(item.itemType);
      if (pluralItemType) {

        if (pluralItemType === "movies") { pluralItemType = "buymovies"; } //Cool Cool API

        const id = item.idInStore || item.itemID;

        this.blocklistService.removeItem(Global.getCountry(), Global.getStore(), pluralItemType,
          sessionToken, item.idInStore)
          .subscribe(res => {

            if (res && res["message"] == BaseService.COULDNT_LOAD_USER) {
              StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
              this.authentication.openLogin();
            }
            else {
              //Success!
              this.updateLocalShortBlocklist(sessionToken);
              this.reload(false);
            }

          }, err => {
            Log.getInstance().d(err);
            this.updateLocalShortBlocklist(sessionToken);
          });
        }
      }
  }

  updateLocalShortBlocklist(sessionToken: string) {
    this.blocklistService.getShortBlocklist(
      Global.getCountry(),
      Global.getStore(),
      sessionToken
    ).subscribe(res => {

      if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.authentication.openLogin();
      }
      else if (res && res["results"]) {
        const shortBlocklist = StorageHelper.getInstance().get(StorageHelper.keys.shortBlocklist) || {};
        shortBlocklist[Global.getStore()] = res["results"];
        const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortBlocklist, shortBlocklist);
        if (saved) {
          ListHelper.clearBlocklistCache();
        } else {
          Log.getInstance().d('Failed to save blocklist to storage - storage may be full');
        }
      }
    },
    err => {
      Log.getInstance().d(err);
    });
  }

  storeIsItunes(): boolean {
    return Global.getStore() === Global.ITUNES;
  }

  threeDotsClicked() {
    if (this.dotsDDContent.nativeElement.classList.contains('dd-open')) {
      this.closeDropdown(this.dotsDDContent);
    }
    else {
      this.openDropdown(this.dotsDDContent);
    }
  }

  closeDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-close';
    }
  }

  openDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-right dd-open';
    }
  }

  getMedia(): string {
    return this.getString(Global.getMediaTypeForWishlistRequest());
  }

}
